<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:38:25
-->
<template>
  <div class="custom-pie custom-pie-min-height">
    <div class="custom-pie-item">
      <svg
        class="svg"
        :width="svgWidth"
        :height="svgHeight"
        :viewport="`0 0 ${svgWidth} ${svgHeight}`"
      >
        <g
          class="svg-content"
          v-for="(aItem, aindex) in pathArrs"
          :key="aindex"
          :style="aItem.style"
        >
          <g
            v-for="(item, index) in aItem.bgP"
            :key="`bg${index}`"
            @mouseenter="$set(pathHover, aindex, true)"
            @mouseleave="$set(pathHover, aindex, false)"
          >
            <path
              class="custom-pie-item-block"
              v-for="(v, k) in item.surfaces"
              :key="k"
              :d="v"
              fill="rgba(182, 194, 216, .16)"
              stroke="red"
              stroke-width="0"
              :data-v="v"
              :data-k="k"
            />
          </g>
          <g
            v-for="(item, index) in aItem.p"
            :key="index"
            @mouseenter="$set(pathHover, aindex, true)"
            @mouseleave="$set(pathHover, aindex, false)"
          >
            <g v-if="item.info.value > 0">
              <path
                class="custom-pie-item-block"
                v-for="(v, k) in item.surfaces"
                :key="k"
                :d="v"
                :fill="
                  colorArr[aItem.index % 6](
                    (k == 'top' ? 1 : k == 'back' ? 0.8 : 0.6) -
                      (pathHover[aindex] ? 0.1 : 0)
                  )
                "
                stroke="red"
                stroke-width="0"
                :data-v="v"
                :data-k="k"
              />
            </g>
            <pieLineText
              :series0data="dealSeries0data"
              :point="item.surfacesPoint.leftTopPointIsAddHeight"
              :label="
                `${item.info.name}${item.info.b ? '：' + item.info.b : ''}`
              "
              :a="a"
              :b="b"
              :index="aItem.index"
              :icon="colorArr[aItem.index % 6](1)"
            />
          </g>
        </g>
      </svg>
    </div>
    <Table :table="table" :normalTable="table && table.isNormal"></Table>
  </div>
</template>

<script>
import { colorArr } from '../color/config.js';
import { getPie } from './common/tools.js';
import Table from '../Table';
import pieLineText from './pieLineText.vue';
export default {
  props: {
    series0data: {
      type: Array,
      default: () => []
    },
    finalDataCount: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: '单'
    },
    table: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      colorArr,
      pathArrs: [],
      pathHover: [],
      a: 60, // 长轴
      b: 60 // 短轴
    };
  },
  components: { Table, pieLineText },
  methods: {},
  computed: {
    svgWidth() {
      const { series0data } = this;
      return Math.max(series0data.length * 100, 300) + 20;
    },
    svgHeight() {
      const { dealSeries0data } = this;
      return Math.max(dealSeries0data.length * 100, 300) + 20;
    },
    dealSeries0data() {
      return this.series0data.reverse();
    }
  },
  created() {
    const { a, b, svgWidth, svgHeight } = this;
    this.pathArrs = this.dealSeries0data
      .reduce((pre, cur, index, arr) => {
        const dis = index * 40;
        pre.push({
          p: getPie({
            data: [cur],
            finalDataCount: this.finalDataCount,
            axis: [a + dis, b + dis],
            miniAxis: [a + dis - 20, b + dis - 20],
            height: 5,
            xMoveDis: -5,
            baseDeg: 270,
            sDeg: 270,
            isAntiClockwise: true
          }),
          bgP: getPie({
            data: [{ value: this.finalDataCount, name: cur.name }],
            finalDataCount: this.finalDataCount,
            axis: [a + dis, b + dis],
            miniAxis: [a + dis - 20, b + dis - 20],
            height: 0,
            baseDeg: 270,
            sDeg: 270,
            isAntiClockwise: true
          }),
          style: `transform: translate(${(svgWidth - a * 2) / 2 -
            dis}px, ${(svgHeight - b * 2) / 2 - dis}px);`,
          index: arr.length - 1 - index
        });
        return pre;
      }, [])
      .reverse();
  },
  mounted() {
    this.$nextTick(() => {
      try {
        document.getElementsByClassName(
          'custom-pie-min-height'
        )[0].style.minHeight =
          document.querySelector('.custom-pie-min-height .bi-table')
            .offsetHeight +
          40 +
          'px';
      } catch (err) {
        console.error(err);
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.custom-pie {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  // flex-wrap: wrap;
  position: relative;
  &-item {
    // margin-left: -20px;
    .p {
      transform: translateY(-10px);
      &-1 {
        font-size: 14px;
        color: #434343;
        line-height: 1;
      }
      &-2 {
        font-size: 24px;
        color: #434343;
        line-height: 1;
        margin-top: 22px;
      }
    }
  }
}
.bi-table {
  position: absolute;
  right: 20px;
  top: 30px;
}
.svg {
  path {
    transition: all 0.3s;
  }
  &-content {
    transform: translate(80px, 130px);
    .custom-pie-item-block {
      cursor: pointer;
    }
    .shodow {
      transform-origin: 120px 55px;
      transform: translateX(-10px) translateY(90px);
    }
  }
}
</style>
